import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGoogleDriveLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 21,
	viewBox: "0 0 24 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M11.5519 6.77327L7.91793 0.360122C8.03858 0.237275 8.1774 0.156697 8.31622 0.102539C7.24459 0.455229 6.75288 1.6586 6.75288 1.6586L0.114206 13.3713C0.020795 13.7386 -0.0051548 14.0701 0.00652159 14.362H7.25237L11.5519 6.77327Z",
			fill: "#34A853"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.5518 6.77327L15.8513 14.362H23.0971C23.1088 14.0701 23.0828 13.7386 22.9894 13.3713L16.3508 1.6586C16.3508 1.6586 15.8578 0.455229 14.7874 0.102539C14.9249 0.156697 15.0651 0.237275 15.1857 0.360122L11.5518 6.77327Z",
			fill: "#FBBC05"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.5519 6.77462L15.1859 0.361479C15.0652 0.238632 14.9251 0.158055 14.7876 0.103896C14.6293 0.0523799 14.4593 0.0180356 14.2751 0.00878906H14.0831H9.02074H8.82873C8.6458 0.0167147 8.47454 0.0510589 8.31626 0.103896C8.17874 0.158055 8.03862 0.238632 7.91797 0.361479L11.5519 6.77462Z",
			fill: "#188038"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.25385 14.3623L3.66142 20.7028C3.66142 20.7028 3.54205 20.6447 3.37988 20.5245C3.88975 20.9168 4.38535 21 4.38535 21H18.4943C19.2728 21 19.4349 20.7028 19.4349 20.7028C19.4375 20.7015 19.4388 20.7002 19.4414 20.6988L15.8516 14.3623H7.25385Z",
			fill: "#4285F4"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.25464 14.3623H0.00878906C0.0451156 15.2236 0.418761 15.7268 0.418761 15.7268L0.691211 16.1997C0.710671 16.2275 0.722346 16.2433 0.722346 16.2433L1.31525 17.2842L2.64635 19.6011C2.68528 19.6949 2.73069 19.7808 2.77869 19.8627C2.79685 19.8904 2.81372 19.9208 2.83318 19.9472C2.83837 19.9551 2.84356 19.9631 2.84875 19.971C3.01351 20.2035 3.19774 20.3831 3.38197 20.5245C3.54414 20.646 3.6635 20.7028 3.6635 20.7028L7.25464 14.3623Z",
			fill: "#1967D2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.8516 14.3623H23.0974C23.0611 15.2236 22.6874 15.7268 22.6874 15.7268L22.415 16.1997C22.3955 16.2275 22.3839 16.2433 22.3839 16.2433L21.7909 17.2842L20.4598 19.6011C20.4209 19.6949 20.3755 19.7808 20.3275 19.8627C20.3093 19.8904 20.2925 19.9208 20.273 19.9472C20.2678 19.9551 20.2626 19.9631 20.2574 19.971C20.0927 20.2035 19.9085 20.3831 19.7242 20.5245C19.5621 20.646 19.4427 20.7028 19.4427 20.7028L15.8516 14.3623Z",
			fill: "#EA4335"
		})
	]
});
export default SvgGoogleDriveLogo;
